import './index.less';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import App from './app';
import { store } from './app/store';
import { initSentry } from './utils/sentry';
// TEMP: remove together with src/utils/SentryTest.tsx after verifying Sentry.

declare global {
  interface Window {
    less: any;
    openZenDeskWidget?: () => void;
    zE?: (a: () => void) => void;
  }
}

initSentry();

ReactDOM.render(
  <Provider store={store}>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <App />
      {/* TEMP: remove after verifying Sentry reporting. */}
    </Sentry.ErrorBoundary>
  </Provider>,
  document.getElementById('root')
);
